// Unpoly global configuration
// Ensures CSRF, navigation, logging, and common behaviors match legacy setup

/**
 * Configure Unpoly with application defaults.
 * Must be called once during app startup.
 */
export function configureUnpoly() {
  // CSRF token provider
  up.protocol.config.csrfToken = function () {
    const element = document.querySelector('[data-csrf-token]')
    if (!element) return ''
    return element.dataset.csrfToken
  }

  // Fragment & navigation defaults
  up.fragment.config.mainTargets.push('main')
  up.status.config.currentClasses = ['active']
  up.link.config.followSelectors.push('a[href]')
  up.form.config.submitSelectors.push(['form'])
  up.fragment.config.navigateOptions.transition = 'cross-fade'
  up.fragment.config.navigateOptions.cache = false

  // Logging based on host
  if (window.location.hostname.toLowerCase() === 'localhost') {
    up.log.enable()
  } else {
    up.log.disable()
  }

  // Auth event
  up.on('auth:change', function () {
    window.location.href = '/'
  })
}

export default configureUnpoly
